<template>
<section class="giphy-picker-section" @scroll.prevent="scrollHandler">
  <div class="search-container">
    <input class="search-box" placeholder="procurar GIF..." type="text" v-model="searchTerm" @keypress.enter="searchTenorAPI">
    <i class="fas fa-search" @click="searchTenorAPI" v-if="searchTerm"></i>
    <button class="reset-btn" @click="resetGifs" v-show="!gifIsEmpty"><i class="fas fa-times-circle"></i></button>
  </div>
  <div class="gif-container" v-show="featuredGifsIsEmpty && !gifIsEmpty">
    <img :class="{'selected-gif': gif===selectedGif}" v-for="(gif, k) in gifs" :src="gif" :key="k" @click.prevent="gifPicked(gif)">
  </div>
  <div class="gif-container" v-show="!featuredGifsIsEmpty && gifIsEmpty">
    <img :class="{'selected-gif': gif===selectedGif}" v-for="(gif, k) in featuredGifs" :src="gif" :key="k" @click.prevent="gifPicked(gif)">
  </div>
</section>
</template>

<script>
const apiKey = "AIzaSyCz0bJbzwbTTxBicViSRYvzY_CU5RS_vBw";

export default {
  name: "GiphyPicker",

  data() {
    return {
      searchTerm: "",
      featuredGifs: [],
      gifs: [],
      selectedGif: null,
      nextFeaturedPos: "",
      nextSearchPos: "",
      limit: 50,
    };
  },

  computed: {
    gifIsEmpty() {
      return this.gifs.length === 0;
    },
    featuredGifsIsEmpty() {
      return this.featuredGifs.length === 0;
    }
  },
  methods: {
    searchTenorAPI() {
      this.featuredGifs = [];
      this.gifs = [];
      this.nextFeaturedPos = "";
      this.nextSearchPos = "";
      this.getGifs();
    },
    async getFeaturedGifs() {
      const locale = navigator.language || 'pt-BR';
      const country = locale.split('-')[1] || 'BR';

      const response = await fetch(`https://tenor.googleapis.com/v2/featured?key=${apiKey}&limit=${this.limit}&pos=${this.nextFeaturedPos}&country=${country}&locale=${locale}&searchfilter=sticker`);
      const data = await response.json();
      this.featuredGifs = [...this.featuredGifs, ...data.results.map(gif => gif.media_formats.tinygif_transparent.url)];
      this.nextFeaturedPos = data.next || "";
    },
    async getGifs() {
      const locale = navigator.language || 'pt-BR';
      const country = locale.split('-')[1] || 'BR';

      const response = await fetch(`https://tenor.googleapis.com/v2/search?q=${this.searchTerm}&key=${apiKey}&limit=${this.limit}&pos=${this.nextSearchPos}&country=${country}&locale=${locale}`);
      const data = await response.json();
      this.gifs = [...this.gifs, ...data.results.map(gif => gif.media_formats.tinygif.url)];
      this.nextSearchPos = data.next || "";
    },
    gifPicked(gif) {
      this.selectedGif = gif;
      this.$emit("picked", this.selectedGif);
    },
    resetGifs() {
      this.searchTerm = "";
      this.selectedGif = null;
      this.gifs = [];
      this.nextFeaturedPos = "";
      this.nextSearchPos = "";
      this.getFeaturedGifs();
    },
    resetSelectedGif() {
      this.selectedGif = null;
    },
    scrollHandler(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop === 0) {
        console.log('scrolling to the top');
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        console.log('scrolling to the bottom');
        if (this.searchTerm) this.getGifs();
        else this.getFeaturedGifs();
      }
    },
    clickOutside(event) {
      if (!event.target) return
      const isClickInside = this.$el.contains(event.target)
        || event.target.classList.contains("gif-btn")
        || (event.target.parentElement && event.target.parentElement.classList.contains("close-picked-btn"))
        || (event.target.parentElement && event.target.parentElement.classList.contains("picked-giphy-container"))
        || (event.target.parentElement && event.target.parentElement.classList.contains("reset-btn"))
        || (event.target.parentElement && event.target.parentElement.classList.contains("search-container"))
        || (event.target.parentElement && event.target.parentElement.classList.contains("gif-container"))
      if (!isClickInside) this.$emit("close")
    }
  },
  mounted() {
    this.getFeaturedGifs();
    document.addEventListener('click', this.clickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside);
  }
};
</script>

<style lang="scss">
.giphy-picker-section {
  position: relative;
  padding: 10px;
  min-height: 10%;
  max-height: 100%;
  width: 100%;
  overflow-y: auto;
  z-index: 1;
  background: #555;
  border: 1px solid #ffffff80;
  border-radius: var(--chat-borderRadius);

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--chat-scrollbarBGColor) !important;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--chat-scrollbarHandleColor) !important;
  }

  .reset-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: white;
    cursor: pointer;
  }

  .search-container {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    .search-box {
      position: relative;
      width: 100%;
      padding: 4px 12px;
      border: none;
      outline: none;
      border-radius: 14px;
    }
  }

  .gif-container {
    position: relative;
    margin-top: 10px;
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    img {
      padding: 2px;
      width: auto;
      max-width: 100px;
      object-fit: contain;
      cursor: pointer;
    }

    .selected-gif {
      border-radius: 8px;
      transform: scale(1.1);
    }
  }
}
</style>